import React, { useState } from "react";
import serviceImage from "../images/services.png";

const Services = () => {
  const [activeService, setActiveService] = useState(null);

  const toggleDetails = (key) => {
    setActiveService(activeService === key ? null : key);
  };

  const services = [
    {
      key: "dissertation",
      title: "Dissertation Writing",
      desc: "Expert dissertation writing services covering proposal creation, literature review, methodology, data analysis, and final presentation with full academic support.",
      img: "https://images.unsplash.com/photo-1501504905252-473c47e087f8?q=80&w=1974&auto=format&fit=crop",
      details: (
        <div className="space-y-4 text-sm leading-relaxed">
          <h2 className="text-xl font-semibold text-white">
            Our Dissertation Writing Coverage
          </h2>
          <ul className="list-disc pl-5 space-y-2">
            <li>Topic selection and proposal writing</li>
            <li>Literature review with proper referencing</li>
            <li>Methodology framework and justification</li>
            <li>Results, analysis, and discussion</li>
            <li>Plagiarism-free content with Turnitin reports</li>
            <li>Formatting as per university guidelines (APA, MLA, etc.)</li>
            <li>Unlimited revisions & expert feedback support</li>
          </ul>
        </div>
      ),
    },
    {
      key: "report",
      title: "Report Writing",
      desc: "Expertly crafted reports with clear structure, detailed analysis, and comprehensive insights to meet academic or professional requirements.",
      img: "https://images.unsplash.com/photo-1592819695396-064b9572a660?q=80&w=2070&auto=format&fit=crop",
      details: (
        <div className="space-y-4 text-sm leading-relaxed">
          <h2 className="text-xl font-semibold text-white">
            Key Elements of a Good Report
          </h2>
          <ul className="list-disc pl-5 space-y-1">
            <li>Clear structure (intro, body, conclusion)</li>
            <li>Evidence-based analysis with references</li>
            <li>Professional formatting and clarity</li>
            <li>Actionable and insightful recommendations</li>
          </ul>
        </div>
      ),
    },
    {
      key: "thesis",
      title: "Thesis Writing",
      desc: "Comprehensive thesis writing services covering research, analysis, and structured presentation to meet your academic goals effectively.",
      img: "https://images.unsplash.com/photo-1731963094554-c5c981ccdefd?q=80&w=2071&auto=format&fit=crop",
      details: (
        <div className="space-y-4 text-sm leading-relaxed">
          <h2 className="text-xl font-semibold text-white">
            Overview of Thesis Writing
          </h2>

          <h3 className="font-semibold text-white">Structure</h3>
          <ul className="list-disc pl-5 space-y-1">
            <li>Introduction</li>
            <li>Literature Review</li>
            <li>Methodology</li>
            <li>Results & Discussion</li>
          </ul>

          <h3 className="font-semibold text-white">Suggestions</h3>
          <ul className="list-disc pl-5 space-y-1">
            <li>Clear research questions</li>
            <li>Strong literature review</li>
            <li>Well-designed methodology</li>
          </ul>

          <h3 className="font-semibold text-white">We Provide</h3>
          <ul className="list-disc pl-5 space-y-1">
            <li>Consultation & guidance</li>
            <li>Editing & proofreading</li>
            <li>Plagiarism-free content</li>
          </ul>
        </div>
      ),
    },
    {
      key: "ppt",
      title: "PPT & Poster Design",
      desc: "Creative and professional presentations and posters designed to communicate your ideas with clarity and visual impact.",
      img: "https://images.unsplash.com/photo-1576085898323-218337e3e43c?q=80&w=2070&auto=format&fit=crop",
      details: (
        <div className="space-y-3 text-sm leading-relaxed">
          <h2 className="text-xl font-semibold text-white">What We Offer</h2>
          <ul className="list-disc pl-5 space-y-1">
            <li>Engaging academic & business slides</li>
            <li>Custom-designed posters</li>
            <li>Brand-consistent visuals</li>
            <li>Unlimited revisions</li>
          </ul>
        </div>
      ),
    },
    {
      key: "essay",
      title: "Essay Writing",
      desc: "High-quality essay writing services meeting academic standards with proper structure, research, and clarity.",
      img: "https://images.unsplash.com/photo-1505682499293-233fb141754c?q=80&w=2071&auto=format&fit=crop",
      details: (
        <div className="space-y-3 text-sm leading-relaxed">
          <h2 className="text-xl font-semibold text-white">
            Why Choose Our Essay Services
          </h2>
          <ul className="list-disc pl-5 space-y-1">
            <li>Customized essays for any topic</li>
            <li>Plagiarism-free content</li>
            <li>Proper academic formatting</li>
            <li>Fast delivery & proofreading</li>
          </ul>
        </div>
      ),
    },
  ];

  return (
    <div className="px-6 py-16 max-w-6xl mx-auto mt-20 bg-[#02042b]">
      <h1 className="text-3xl md:text-5xl font-extrabold text-center mb-12 
      text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-yellow-600">
        Professional Writing & Design Services
      </h1>

      <div className="flex justify-center mb-14">
        <img
          src={serviceImage}
          alt="Professional Services"
          className="w-full max-w-3xl rounded-xl shadow-2xl object-cover"
        />
      </div>

      {services.map((service, index) => (
        <div
          key={service.key}
          className={`flex flex-col md:flex-row items-center gap-10 mb-24 
            ${index % 2 !== 0 ? "md:flex-row-reverse" : ""} 
            hover:-translate-y-1 hover:shadow-2xl transition`}
        >
          {/* IMAGE */}
          <div className="w-full md:w-1/2">
            <img
              src={service.img}
              alt={service.title}
              className="rounded-2xl shadow-xl w-full h-80 object-cover"
            />
          </div>

          {/* CONTENT */}
          <div className="w-full md:w-1/2">
            <h2 className="text-2xl md:text-3xl font-bold mb-4
            text-transparent bg-clip-text bg-gradient-to-r from-blue-200 to-purple-400">
              {service.title}
            </h2>

            <p className="text-gray-200 mb-6 leading-relaxed">
              {service.desc}
            </p>

            <div className="flex flex-wrap gap-4 mb-4">
              <a
                href="tel:+917980085981"
                className="bg-gradient-to-r from-red-500 to-red-600 text-white px-6 py-2.5 
                rounded-full shadow hover:brightness-110 transition"
              >
                Get Quote
              </a>

              <button
                onClick={() => toggleDetails(service.key)}
                className="bg-gradient-to-r from-blue-500 to-blue-600 text-white px-6 py-2.5 
                rounded-full shadow hover:brightness-110 transition"
              >
                {activeService === service.key ? "Hide Details" : "Read More"}
              </button>
            </div>

            {activeService === service.key && (
              <div className="mt-4 bg-white/5 p-6 rounded-2xl text-gray-200 border border-white/10">
                {service.details}
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Services;
